import { useMemo } from "react";

import { groupLocationOptions } from "src/components/Dashboard/LocationSearch/locationSearch.helper";
import { LocationModel } from "src/types/location";
import LocationType from "src/types/LocationType";

export type GroupedRegion = {
  region: { id: string; label: string; isVirtualRegion: boolean };
  type: LocationType;
  children: Array<{ id: string; label: string }>;
};

export function useGroupedLocations(
  locationList: Array<LocationModel> | undefined,
  locationType: LocationType
): { grouped: GroupedRegion[]; isSingleRegion: boolean } {
  return useMemo(() => {
    const list = Array.isArray(locationList) ? locationList : [];
    const grouped = groupLocationOptions(list).filter((g) => g.type === locationType);

    return { grouped, isSingleRegion: grouped.length === 1 };
  }, [locationList, locationType]);
}
